export default __webpack_public_path__ + "static/media/logo_acelerador.c13a4c4a.svg";